import React from 'react'
import StatisticsScreen from './StatisticsScreen';
import "./StatisticsContainer.css"
import useLogReport from '../../util/hooks/useLogReport';

const StatisticsContainer = () => {


    // Log report for the page
    useLogReport('STATISTICS');


    return (

        <StatisticsScreen />

    )
}

export default StatisticsContainer